export const labelStyles = {
  position: "absolute",
  top: "-16px",
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: "#FF6B00",
  color: "white",
  padding: "6px 16px",
  borderRadius: "30px",
}